// extracted by mini-css-extract-plugin
export default {"container":"NotAvailableScreen_container__MR4iA"};